/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { ReportRunMetadataDto } from './ReportRunMetadataDto';
export type ReportRunResponseDto = {
    id: string;
    reportType: ReportRunResponseDto.reportType;
    filters?: Record<string, any>;
    status: ReportRunResponseDto.status;
    ranAt: string;
    ranByName: string;
    ranByEmail: string;
    metadata?: ReportRunMetadataDto | null;
};
export namespace ReportRunResponseDto {
    export enum reportType {
        BORDEAUX = 'BORDEAUX',
        DEBTORS = 'DEBTORS',
        CASH_CREDITS = 'CASH_CREDITS',
        COMMISSIONS = 'COMMISSIONS',
        RENEWAL_PIPELINE = 'RENEWAL_PIPELINE',
        ADVISER_PERFORMANCE = 'ADVISER_PERFORMANCE',
        BUSINESS_WRITTEN = 'BUSINESS_WRITTEN',
        POLICY_RENEWAL = 'POLICY_RENEWAL',
    }
    export enum status {
        COMPLETED = 'COMPLETED',
        FAILED = 'FAILED',
    }
}

